import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import DefaultTemplate from "../templates/DefaultTemplate.vue";
import RightSpacedTemplate from "../templates/RightSpacedTemplate.vue";
import AuthTemplate from "../templates/AuthTemplate.vue";
import BlankTemplate from "../templates/BlankTemplate.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      title:
        "Página Inicial - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: DefaultTemplate,
      protected: true,
    },
  },
  {
    path: "/",
    name: "account",
    component: HomeView,
    meta: {
      title: "Conta - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: DefaultTemplate,
      protected: true,
    },
  },
  {
    path: "/minha-conta",
    name: "account",
    component: () => import("../views/AccountInfoView.vue"),
    meta: {
      title: "Minha Conta - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: RightSpacedTemplate,
      protected: true,
    },
  },
  {
    path: "/meu-perfil",
    name: "my-profile",
    component: () => import("../views/MyProfileView.vue"),
    meta: {
      title: "Meu Perfil - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: RightSpacedTemplate,
      protected: true,
    },
  },
  {
    path: "/mestres",
    name: "masters",
    component: () => import("../views/MastersView.vue"),
    meta: {
      title: "Mestres - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: DefaultTemplate,
      protected: true,
    },
  },
  {
    path: "/mestres/:id",
    name: "master-view",
    component: () => import("../views/MasterContentView.vue"),
    meta: {
      title:
        "Sobre o Mestre - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: DefaultTemplate,
      protected: true,
    },
  },
  {
    path: "/biblioteca/:id?",
    name: "library",
    component: () => import("../views/LibraryView.vue"),
    meta: {
      title: "Livros - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: DefaultTemplate,
      protected: true,
    },
  },
  {
    path: "/ebook/:id",
    name: "ebook",
    component: () => import("../views/EbookView.vue"),
    meta: {
      title: "Livro - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: BlankTemplate,
      protected: true,
    },
  },
  {
    path: "/conferencia-fiel",
    name: "conferences",
    component: () => import("../views/ConferenceView.vue"),
    meta: {
      title: "Conferências - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: DefaultTemplate,
      protected: true,
    },
  },
  {
    path: "/conferencia/:id/aula/:lesson_id",
    name: "conference-lesson",
    component: () => import("../views/ConferenceLesson.vue"),
    meta: {
      title: "Palestra - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: DefaultTemplate,
      protected: true,
    },
  },
  {
    path: "/curso/:id/aula/:lesson_id",
    name: "lesson",
    component: () => import("../views/Lesson.vue"),
    meta: {
      title: "Aula - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: DefaultTemplate,
      protected: true,
    },
  },
  {
    path: "/conferencia/:id",
    name: "conference-about",
    component: () => import("../views/ConferenceInfosView.vue"),
    meta: {
      title:
        "Sobre a Conferência - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: DefaultTemplate,
      protected: true,
    },
  },
  {
    path: "/minha-lista",
    name: "my-list",
    component: () => import("../views/MyListView.vue"),
    meta: {
      title: "Minha Lista - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: DefaultTemplate,
      protected: true,
    },
  },
  {
    path: "/cursos",
    name: "courses",
    component: () => import("../views/CoursesView.vue"),
    meta: {
      title: "Cursos - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: DefaultTemplate,
      protected: true,
    },
  },
  {
    path: "/busca",
    name: "search",
    component: () => import("../views/SearchView.vue"),
    meta: {
      title:
        "Resultado da Pesquisa - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: DefaultTemplate,
      protected: true,
    },
  },
  {
    path: "/curso/:id",
    name: "course-about",
    component: () => import("../views/CourseAboutView.vue"),
    meta: {
      title: "Sobre o Curso - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: DefaultTemplate,
      protected: true,
    },
  },
  {
    path: "/avaliacao-curso/:id",
    name: "course-test",
    component: () => import("../views/CourseExamView.vue"),
    meta: {
      title:
        "Avaliação do Curso - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: DefaultTemplate,
      protected: true,
    },
  },
  {
    path: "/kids/:id?",
    name: "kids",
    component: () => import("../views/KidsView.vue"),
    meta: {
      title: "Fiel Kids - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: DefaultTemplate,
      protected: true,
    },
  },
  {
    path: "/artigos",
    name: "articles",
    component: () => import("../views/ArticlesView.vue"),
    meta: {
      title: "Artigos - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: DefaultTemplate,
      protected: true,
    },
  },
  {
    path: "/podcasts",
    name: "podcasts",
    component: () => import("../views/PodcastsView.vue"),
    meta: {
      title: "Podcasts - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: DefaultTemplate,
      protected: true,
    },
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/LoginView.vue"),
    meta: {
      title: "Entrar - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: AuthTemplate,
      protected: false,
    },
  },
  {
    path: "/assinatura",
    name: "signature",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/SignatureView.vue"),
    meta: {
      title: "Assinatura - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: RightSpacedTemplate,
      protected: true,
    },
  },
  {
    path: "/assinatura/gerenciar",
    name: "subscription-manager",
    component: () =>
      import(
        /* webpackChunkName: "login" */ "../views/SubscriptionManager.vue"
      ),
    meta: {
      title:
        "Gerenciar Assinatura - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: DefaultTemplate,
      protected: true,
    },
  },
  {
    path: "/planos",
    name: "plans",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Plans.vue"),
    meta: {
      title: "Planos - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: DefaultTemplate,
      protected: true,
    },
  },
  {
    path: "/cadastro",
    name: "register",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/RegisterView.vue"),
    meta: {
      title: "Cadastro - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: AuthTemplate,
      protected: false,
    },
  },
  {
    path: "/reset-password",
    name: "resetPassword",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/ResetPasswordView.vue"),
    meta: {
      title:
        "Recuperar Senha - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: AuthTemplate,
      protected: false,
    },
  },
  {
    path: "/404",
    name: "404",
    component: () => import("../views/NotFoundView.vue"),
    meta: {
      title:
        "Página Não Encontrada - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: DefaultTemplate,
      protected: false,
    },
  },
  {
    path: "/politica-privacidade",
    name: "privacy",
    component: () => import("../views/PrivacyView.vue"),
    meta: {
      title:
        "Política de Privacidade - Fiel Digital - Uma Plataforma do Ministério Fiel",
      template: BlankTemplate,
      protected: false,
    },
  },
  {
    path: "/:catchAll(.*)", // Unrecognized path automatically matches 404
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title =
    to.meta.title || "Fiel Digital - Uma Plataforma do Ministério Fiel";
  next();
});

export default router;
